import * as React from "react";

function SvgGraduationHatDuo({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="#374151"
          d="M14.415 3.356l.227.119 6.174 3.43c1.728.96 1.782 3.398.162 4.45l-.162.098-2.1 1.166v3.505c0 1.111-.52 2.154-1.4 2.82l-.18.129-1.607 1.069a6.375 6.375 0 01-6.828.147l-.231-.147-1.607-1.07a3.538 3.538 0 01-1.573-2.727l-.007-.221-.001-3.505-2.098-1.166c-1.728-.96-1.782-3.398-.162-4.45l.162-.098 6.175-3.43a5.444 5.444 0 015.056-.119zm-4.15 1.247l-.217.112-6.174 3.43a1.183 1.183 0 00-.116 1.995l.116.073 6.173 3.43a4.027 4.027 0 003.688.112l.217-.112 6.174-3.43c.771-.428.81-1.502.116-1.995l-.116-.073-6.173-3.43a4.027 4.027 0 00-3.688-.112z"
        />
        <path
          fill="#98DB69"
          d="M17.299 13.406l-2.658 1.477c-1.568.87-3.46.91-5.056.119l-.227-.119L6.7 13.406v2.718c0 .652.3 1.264.805 1.665l.143.104 1.607 1.07a4.959 4.959 0 005.28.132l.21-.133 1.608-1.069a2.12 2.12 0 00.94-1.592l.008-.177-.001-2.718z"
        />
      </g>
    </svg>
  );
}

export default SvgGraduationHatDuo;
